import React, { useState } from 'react';
import {
  ACTIVIDAD_LABELS,
  labelFromMap,
  TIPOS_ACTIVIDAD_PROSPECTO,
} from '../../services/prospectosCrmService';

const INITIAL = {
  tipoActividad: 'NOTA',
  comentario: '',
  fechaProximoSeguimiento: '',
};

export default function ProspectoActividadForm({ onSubmit, saving = false }) {
  const [form, setForm] = useState(INITIAL);
  const [error, setError] = useState('');

  const update = (event) => {
    const { name, value } = event.target;
    setForm((actual) => ({ ...actual, [name]: value }));
    setError('');
  };

  const submit = async (event) => {
    event.preventDefault();

    if (!form.comentario.trim()) {
      setError('El comentario es requerido.');
      return;
    }

    const ok = await onSubmit?.({
      tipoActividad: form.tipoActividad,
      comentario: form.comentario.trim(),
      fechaProximoSeguimiento: form.fechaProximoSeguimiento || null,
    });

    if (ok !== false) {
      setForm(INITIAL);
    }
  };

  return (
    <form className="crm-prospectos-actividad-form" onSubmit={submit}>
      <label>
        <span>Tipo de actividad</span>
        <select name="tipoActividad" value={form.tipoActividad} onChange={update}>
          {TIPOS_ACTIVIDAD_PROSPECTO.map((tipo) => (
            <option key={tipo} value={tipo}>{labelFromMap(ACTIVIDAD_LABELS, tipo)}</option>
          ))}
        </select>
      </label>
      <label className="is-wide">
        <span>Comentario</span>
        <textarea name="comentario" value={form.comentario} onChange={update} rows="3" placeholder="Describe el seguimiento realizado" />
      </label>
      <label>
        <span>Nueva fecha de seguimiento</span>
        <input name="fechaProximoSeguimiento" type="datetime-local" value={form.fechaProximoSeguimiento} onChange={update} />
      </label>
      {error ? <p className="crm-prospectos-feedback is-error">{error}</p> : null}
      <button type="submit" className="is-primary" disabled={saving}>{saving ? 'Guardando...' : 'Registrar actividad'}</button>
    </form>
  );
}
